import { Backdrop, Button, TextField } from "@mui/material";

const TextFieldPrompt = ({
  open,
  setOpen,
  value,
  setValue,
  onSave,
}: {
  open: boolean;
  setOpen: (state: boolean) => void;
  value: string;
  setValue: (state: string) => void;
  onSave: () => void;
}) => {
  return (
    <Backdrop
      sx={{
        alignItems: "flex-start",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        paddingTop: "4rem",
        paddingBottom: "4rem",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        overflow: "auto",
      }}
      open={open}
    >
      <div className="bg-white rounded-md p-8">
        <TextField
          required
          value={value}
          onChange={(e) => setValue(e.target.value)}
          variant="outlined"
          sx={{
            width: "100%",
          }}
          size="small"
        />
        <div className="mt-4 flex gap-4 justify-end">
          <Button
            onClick={() => setOpen(false)}
            color="secondary"
            size="small"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            color="primary"
            size="small"
            variant="outlined"
          >
            Save
          </Button>
        </div>
      </div>
    </Backdrop>
  );
};

export default TextFieldPrompt;
